import { EstimationVariancePoint } from '@/features/TimeStatsModel';
import { getTrackerUrl } from '@/utils/getTrackerUrl';

import { formatMinutes, formatSignedPercent } from './utils';

import s from './TimeEstimationScatterChart.module.scss';

type Props = {
  active?: boolean;
  payload?: Array<{ payload: EstimationVariancePoint & { displayTimestamp: number } }>;
  colorByStatus?: Record<string, string>;
};

export const EstimationScatterTooltip: React.FC<Props> = ({ active, payload, colorByStatus }) => {
  if (!active || !payload?.length) {
    return null;
  }

  const point = payload[0].payload;
  const statusColor = colorByStatus?.[point.statusKey] || '#1976d2';

  return (
    <div className={s.tooltip} data-testid="estimation-scatter-tooltip">
      <a
        className={s.tooltip__title}
        href={getTrackerUrl(point.taskKey)}
        target="_blank"
        rel="noopener noreferrer"
      >
        {point.taskKey}
      </a>
      <p className={s.tooltip__row}>{point.summary}</p>
      <p className={s.tooltip__row}>
        <span
          className={s.chart__legend_dot}
          style={{ background: statusColor, display: 'inline-block' }}
        />{' '}
        Статус: {point.statusDisplay}
      </p>
      <p className={s.tooltip__row}>
        Факт (всего) {formatMinutes(point.spentMinutes)} · Оценка{' '}
        {formatMinutes(point.estimateMinutes)} · {formatSignedPercent(point.deltaPercent)}
      </p>
    </div>
  );
};
